module.exports = __webpack_public_path__ + "img/社委中心.278ae714.png";